// @flow
import React from 'react';
import { useIntl } from 'react-intl';

import Dropdown, { type Option } from '../../../../../components/FormControls/Dropdown';
import useSelfEnrollment from '../../../../../hooks/useSelfEnrollment';

type Props = {
  value: string,
  onChange: () => void,
};

const IdentificationTypeSelector = ({ value, onChange }: Props) => {
  const { formatMessage } = useIntl();
  const { entityData } = useSelfEnrollment();

  let options: Option[] = [];

  if (entityData?.selfEnrollment?.selfEnrollmentPatientIdentifiers) {
    const allowedIds = entityData.selfEnrollment.selfEnrollmentPatientIdentifiers.map((id) => id.identifierId);
    options = (entityData?.identifierTypes || [])
      .filter((identifierType) => allowedIds.includes(identifierType.id))
      .map((identifierType) => ({
        value: identifierType.id,
        label: identifierType.displayName,
      }));
  }

  return (
    <>
      <Dropdown
        input={{
          name: `identificationType`,
          value,
          onChange,
        }}
        placeholder={formatMessage({ id: 'app.self-enroll.identify.form.select-identification-type' })}
        options={options}
        meta={{ touched: true, error: '' }}
      />
    </>
  );
};

export default IdentificationTypeSelector;
